import { Button } from "@/components/ui/button";
import {
  ArrowRight,
  Check,
  CreditCard,
  MapPin,
  Shield,
  Truck,
} from "lucide-react";

interface CardPriceNewProps {
  onNext?: () => void;
  quotePrice?: {
    total: number;
  };
}

export default function CardPriceNew({
  onNext,
  quotePrice,
}: CardPriceNewProps) {
  const price = quotePrice?.total || 0;

  const inclusions = [
    { icon: Check, text: "Vistoria digital" },
    { icon: MapPin, text: "Rastreamento On-line" },
    { icon: Truck, text: "Transporte Base a Base" },
    { icon: Shield, text: "Seguro contra roubo e acidentes" },
    { icon: CreditCard, text: "Pagamento facilitado no cartão de crédito" },
  ];

  return (
    <div
      className="bg-white rounded-[32px] overflow-hidden px-8 py-6"
      style={{
        boxShadow:
          "0 20px 60px rgba(134, 239, 172, 0.35), 0 8px 20px rgba(0, 0, 0, 0.08)",
      }}
    >
      <div className=" text-center">
        <h2 className="text-2xl font-semibold text-n-text-green mb-2">
          Transporte Base a Base
        </h2>
        <p className="text-n-text-neutral font-semibold mb-2">a partir de:</p>
        <div className="mb-3">
          <span className="text-4xl font-bold text-n-text-green">
            R${" "}
            {price.toLocaleString("pt-BR", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </span>
        </div>
        <div className="relative">
          <div className="absolute inset-x-0 top-1/2 -translate-y-1/2 h-[2px] bg-gradient-to-r from-transparent via-n-text-green/30 to-transparent" />
          <div className="relative inline-block bg-n-beige px-4 py-1 rounded-full">
            <span className="text-sm font-medium text-black">
              Pix, Boleto ou Cartão de Crédito
            </span>
          </div>
        </div>
      </div>

      <div className="mt-2">
        <h3 className="text-base font-semibold text-n-text-neutral mb-4">
          Incluso no seu orçamento:
        </h3>
        <ul className="space-y-3">
          {inclusions.map((item, index) => {
            const Icon = item.icon;
            return (
              <li key={index} className="flex items-center gap-3">
                <Icon className="w-6 h-6 text-n-text-green flex-shrink-0" />
                <span className="text-sm text-n-text-neutral ">
                  {item.text}
                </span>
              </li>
            );
          })}
        </ul>
      </div>

      <div className=" my-4">
        <p className="text-sm  text-n-text-neutral leading-relaxed">
          Preço estimado. Confirme disponibilidade, prazo exato e opções de
          coleta com um especialista.{" "}
          <a
            href="#"
            className="font-semibold text-n-text-green underline hover:text-n-green-action transition-colors"
          >
            Fale com um especialista no Whatsapp.
          </a>
        </p>
      </div>

      <div className="">
        <Button className="w-full" onClick={onNext}>
          Quero esta oferta
          <ArrowRight className="ml-2 " />
        </Button>
      </div>
    </div>
  );
}
